import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { PortalShell, inputCls, goldBtn } from "@/pages/partner/PartnerLoginPage";
import { VENDOR_TOKEN_KEY, cvErr } from "@/lib/vendorApi";

export default function VendorLoginPage() {
  const nav = useNavigate();
  const [phone, setPhone] = useState("");
  const [pin, setPin] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setError(null);
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/sign-in`, { identifier: phone, pin, group: "contract_vendor" });
      localStorage.setItem(VENDOR_TOKEN_KEY, data.token);
      nav("/vendor");
    } catch (err) { setError(cvErr(err)); } finally { setBusy(false); }
  };
  return (
    <PortalShell title="Contract Vendor sign in" testid="vendor-login-page">
      <form onSubmit={submit} className="space-y-4">
        <label className="block text-sm text-white/70">Mobile number
          <input data-testid="vendor-login-phone" type="tel" inputMode="tel" autoComplete="tel" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="(843) 555-0123" className={`${inputCls} mt-1`} /></label>
        <label className="block text-sm text-white/70">6-digit PIN
          <input data-testid="vendor-login-pin" type="password" inputMode="numeric" autoComplete="current-password" value={pin} onChange={(e) => setPin(e.target.value.replace(/\D/g, "").slice(0, 6))} className={`${inputCls} mt-1 tracking-[0.4em]`} /></label>
        {error && <p className="text-sm text-red-300" data-testid="vendor-login-error">{error}</p>}
        <button type="submit" disabled={busy || !phone.trim() || pin.length !== 6} data-testid="vendor-login-submit" className={goldBtn}>{busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in</button>
        <p className="text-xs text-white/40">Your sign-in details came by text from The Exchange Alliance. Lost your PIN? Ask your TEA contact to set a new one.</p>
      </form>
    </PortalShell>
  );
}
